import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaSave, FaThumbsUp } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import { buscarCep, data, dataHora, dataMysql, extract } from '../../../util/util';
import ReactSelect from '../../../components/ReactSelect';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import moment from 'moment';
import Data from '../../../components/Data';
import { getText, getParticipantLanguage } from '../../../util/translations';

export default function CadastroEventoParticipanteConvite({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem("perfil");
    const [dados, setDados] = useState({ evento: { camposQuestionario: {} } });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const history = useHistory();
    let { state } = useLocation();
    //var idEvento = state?.evento ?? null;
    const idioma = dados?.idioma || state?.idioma || null;

    const preencherCep = (cep, dadosAtuais) => {
        buscarCep(cep).then((resposta) => {
            if (!resposta.erro) {
                setDados({
                    ...dadosAtuais,
                    ...{
                        enderecobairro: resposta.bairro,
                        enderecocomplemento: resposta.complemento,
                        enderecologradouro: resposta.logradouro,
                        enderecopais: "30",
                        nomeEnderecopais: "Brasil",
                        enderecomunicipio: resposta.ibge,
                        nomeEnderecomunicipio: resposta.localidade
                    }
                });
            }
        });
    }

    const buscar = () => {
        setIsLoading(true);
        setIsError(false);
        api({
            method: "get",
            action: '/participante/' + id,
            token: token,
        }).then(response => {
            //extrai dados internos para o array principal
            var dadosRecebidos = extract({
                jsonLaravel: response.data.data,
                chaves: [
                    'enderecopais',
                    'aereomunicipioembarque',
                    'enderecomunicipio',
                    'banco',
                ]
            });



            delete dadosRecebidos.nome;
            dadosRecebidos.datanascimento = data(dadosRecebidos.datanascimento);
            //se estiver em alguma situação do grupo "confirmado" ou "declinaram", mostrar concluído
            var gruposSituacao = dadosRecebidos.grupoSituacao ?? [];
            if (gruposSituacao.includes("confirmados") || gruposSituacao.includes("declinaram")) {
                history.push({
                    pathname: "/cadastroEventoParticipanteConviteConcluido/" + dadosRecebidos.evento.id,
                    state: { idioma: dadosRecebidos.idioma }
                });
                return;
            }

            dadosRecebidos.evento.camposQuestionario = dadosRecebidos.evento.camposQuestionario ?
                JSON.parse(dadosRecebidos.evento.camposQuestionario) :
                {
                    "tipoparticipante": "sim",
                    "nome": "sim",
                    "assinaturaListaPresenca": "sim",
                    "telefone": "sim",
                    "email": "sim",
                    "especialidade": "sim",
                    "rg": "sim",
                    "crm": "sim",
                    "crmuf": "sim",
                    "datanascimento": "sim",
                    "cpf": "sim",
                    "enderecologradouro": "sim",
                    "endereconumero": "sim",
                    "enderecocomplemento": "sim",
                    "enderecocep": "sim",
                    "enderecobairro": "sim",
                    "aereomunicipioembarque": "sim",
                    "enderecomunicipionome": "sim",
                    "enderecomunicipiouf": "sim",
                };

            if (dadosRecebidos.pcd) {
                dadosRecebidos.pcdCheck = true;
            }

            if (dadosRecebidos.restricaoalimentar) {
                dadosRecebidos.restricaoalimentarCheck = true;
            }

            setDados(dadosRecebidos);
            setIsLoading(false);
        }).catch(err => {
            toast.error(getText('errorLoading', getParticipantLanguage(dados)) + getText('errorLoadingDefault', getParticipantLanguage(dados)));
            //console.log(err)
        });
    };//buscar

    const validar = async () => {
        if ((dados.evento.camposQuestionario.nome ?? "nao") === "sim") {
            var nome = document.querySelector("#nome");
            if ((dados.nome ?? '') === '') {
                toast.error(getText('requiredField', idioma) + ': ' + getText('nome_completo_documento_label', idioma));
                setTimeout(() => {
                    nome.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.evento.camposQuestionario.contato ?? "nao") === "sim") {
            var contato = document.querySelector("#contato");
            if ((dados.contato ?? '') === '') {
                toast.error(getText('requiredField', idioma) + ': ' + getText('nome_cracha_label', idioma));
                setTimeout(() => {
                    contato.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.evento.camposQuestionario.celular ?? "nao") === "sim") {
            var celular = document.querySelector("#celular");
            if ((dados.celular ?? '') === '') {
                toast.error(getText('requiredField', idioma) + ': ' + getText('celular_label', idioma));
                setTimeout(() => {
                    celular.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.evento.camposQuestionario.telefone ?? "nao") === "sim") {
            var telefone = document.querySelector("#telefone");
            if ((dados.telefone ?? '') === '') {
                toast.error(getText('requiredTelefone', idioma));
                setTimeout(() => {
                    telefone.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.evento.camposQuestionario.email ?? "nao") === "sim") {
            var email = document.querySelector("#email");
            if ((dados.email ?? '') === '') {
                toast.error(getText('requiredEmail', idioma));
                setTimeout(() => {
                    email.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.evento.camposQuestionario.rg ?? "nao") === "sim") {
            var rg = document.querySelector("#rg");
            if ((dados.rg ?? '') === '') {
                toast.error(getText('requiredRg', idioma));
                setTimeout(() => {
                    rg.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.evento.camposQuestionario.cpf ?? "nao") === "sim") {
            var cpf = document.querySelector("#cpf");
            if ((dados.cpf ?? '') === '') {
                toast.error(getText('requiredCpf', idioma));
                setTimeout(() => {
                    cpf.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.evento.camposQuestionario.crm ?? "nao") === "sim") {
            var crm = document.querySelector("#crm");
            if ((dados.crm ?? '') === '') {
                toast.error(getText('requiredCrm', idioma));
                setTimeout(() => {
                    crm.focus();
                }, 500);
                return false;
            }
        }


        if ((dados.evento.camposQuestionario.crmuf ?? "nao") === "sim") {
            var crmuf = document.querySelector("#crmuf");
            if ((dados.crmuf ?? '') === '') {
                toast.error(getText('requiredCrmUf', idioma));
                setTimeout(() => {
                    crmuf.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.evento.camposQuestionario.datanascimento ?? "nao") === "sim") {
            var datanascimento = document.querySelector("#datanascimento");
            if ((dados.datanascimento ?? '') === '') {
                toast.error(getText('requiredDataNascimento', idioma));
                setTimeout(() => {
                    datanascimento.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.evento.camposQuestionario.especialidade ?? "nao") === "sim") {
            var especialidade = document.querySelector("#especialidade");
            if ((dados.especialidade ?? '') === '') {
                toast.error(getText('requiredEspecialidade', idioma));
                setTimeout(() => {
                    especialidade.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.evento.camposQuestionario.instituicao ?? "nao") === "sim") {
            var instituicao = document.querySelector("#instituicao");
            if ((dados.instituicao ?? '') === '') {
                toast.error(getText('requiredInstituicao', idioma));
                setTimeout(() => {
                    instituicao.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.evento.camposQuestionario.enderecocep ?? "nao") === "sim") {
            var enderecocep = document.querySelector("#enderecocep");
            if ((dados.enderecocep ?? '') === '') {
                toast.error(getText('requiredCep', idioma));
                setTimeout(() => {
                    enderecocep.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.evento.camposQuestionario.enderecologradouro ?? "nao") === "sim") {
            var enderecologradouro = document.querySelector("#enderecologradouro");
            if ((dados.enderecologradouro ?? '') === '') {
                toast.error(getText('requiredRua', idioma));
                setTimeout(() => {
                    enderecologradouro.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.evento.camposQuestionario.endereconumero ?? "nao") === "sim") {
            var endereconumero = document.querySelector("#endereconumero");
            if ((dados.endereconumero ?? '') === '') {
                toast.error(getText('requiredNumero', idioma));
                setTimeout(() => {
                    endereconumero.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.evento.camposQuestionario.enderecobairro ?? "nao") === "sim") {
            var enderecobairro = document.querySelector("#enderecobairro");
            if ((dados.enderecobairro ?? '') === '') {
                toast.error(getText('requiredBairro', idioma));
                setTimeout(() => {
                    enderecobairro.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.evento.camposQuestionario.enderecomunicipio ?? "nao") === "sim") {
            var enderecomunicipio = document.querySelector("#enderecomunicipio");
            if ((dados.enderecomunicipio ?? '') === '') {
                toast.error(getText('requiredMunicipio', idioma));
                setTimeout(() => {
                    enderecomunicipio.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.aereo ?? "nao") === "sim") {
            if ((dados.evento.camposQuestionario.aereomunicipioembarque ?? "nao") === "sim") {
                var aereomunicipioembarque = document.querySelector("#aereomunicipioembarque");
                if ((dados.aereomunicipioembarque ?? '') === '') {
                    toast.error(getText('requiredCidadeEmbarque', idioma));
                    setTimeout(() => {
                        aereomunicipioembarque.focus();
                    }, 500);
                    return false;
                }
            }
        }

        if ((dados.evento.camposQuestionario.enderecouf ?? "nao") === "sim") {
            var enderecouf = document.querySelector("#enderecouf");
            if ((dados.enderecouf ?? '') === '') {
                toast.error(getText('requiredEstado', idioma));
                setTimeout(() => {
                    enderecouf.focus();
                }, 500);
                return false;
            }
        }

        if ((dados.evento.camposQuestionario.necessidadeespecial ?? "nao") === "sim") {
            if ((dados.restricaoalimentarCheck ?? false) === true) {
                var restricaoalimentar = document.querySelector("#restricaoalimentar");
                if ((dados.restricaoalimentar ?? '') === '') {
                    toast.error(getText('requiredRestricaoAlimentar', idioma));
                    setTimeout(() => {
                        restricaoalimentar.focus();
                    }, 500);
                    return false;
                }
            }
            if ((dados.pcdCheck ?? false) === true) {
                var pcd = document.querySelector("#pcd");
                if ((dados.pcd ?? '') === '') {
                    toast.error(getText('requiredPcd', idioma));
                    setTimeout(() => {
                        pcd.focus();
                    }, 500);
                    return false;
                }
            }
        }


        for (let i = 1; i <= 10; i++) {
            if ((dados.evento.camposQuestionario[`coluna${i}`] ?? "nao") === "sim") {
                const coluna = document.querySelector(`#coluna${i}`);
                if ((dados[`coluna${i}`] ?? '') === '') {
                    toast.error(getText('requiredColumn', idioma) + `: ${dados.evento?.[`nomecoluna${i}`] ?? `Coluna ${i}`}`);
                    setTimeout(() => {
                        coluna?.focus();
                    }, 500);
                    return false;
                }
            }
        }

        return true;
    };

    const salvar = async () => {

        if (!dados.evento.id) {
            toast.error(getText('errorLoading', getParticipantLanguage(dados)) + getText('errorLoadingDefault', getParticipantLanguage(dados)));
            return false;
        }

        if (!(await validar())) {
            return false;
        }

        setIsSubmitting(true);

        var idEvento = dados.evento.id;
        let dadosSalvar = { ...dados };

        if (dadosSalvar.datanascimento) {
            dadosSalvar.datanascimento = dataMysql(dadosSalvar.datanascimento);
        }

        dadosSalvar.dataconfirmacaodados = moment().format('YYYY-MM-DD');

        delete dadosSalvar.restricaoalimentarCheck;
        delete dadosSalvar.pcdCheck;
        delete dadosSalvar.hoteldatacheckin;
        delete dadosSalvar.hoteldatacheckout;
        delete dadosSalvar.dataopcaoaereo;
        delete dadosSalvar.datacartainformativa;
        delete dadosSalvar.dataconfirmacaocartainformativa;
        delete dadosSalvar.datacartaconvite;
        delete dadosSalvar.datacartaassinada;
        delete dadosSalvar.dataescolhaaereo;
        delete dadosSalvar.datainscricao;
        delete dadosSalvar.datacertificado;

        delete dadosSalvar.tiposla;
        delete dadosSalvar.evento;
        delete dadosSalvar.hotelmunicipio;
        delete dadosSalvar.cargo;
        delete dadosSalvar.categoria;
        delete dadosSalvar.logomarca;
        delete dadosSalvar.tipoparticipante;

        api({
            method: 'put',
            action: '/participante/' + id,
            token: token,
            data: {
                ...dadosSalvar,
                ...{ dadosConfirmados: true },
            }
        })
            .then(function (response) {
                if (dadosSalvar.aereo === 'sim') {
                    //se o evento foi o id 949258041755025727 ou 806754221753824904 vai para cadastroEventoParticipanteAereoPreencherConvite
                    //se nao for, vai para cadastroEventoParticipanteAereoConvite
                    //if (idEvento === '949258041755025727' || idEvento === '806754221753824904') {
                    //    history.push("/cadastroEventoParticipanteAereoPreencherConvite/" + id);
                    //    return;
                    //}
                    history.push("/cadastroEventoParticipanteAereoConvite/" + id, { idioma: idioma });
                    return;
                }
                if (dadosSalvar.transfer === 'sim' || dadosSalvar.transferextra === 'sim') {
                    history.push("/cadastroEventoParticipanteTransferConvite/" + id, { idioma: idioma });
                    return;
                }
                if (dadosSalvar.hotelhospedagem === 'sim') {
                    history.push("/cadastroEventoParticipanteHotelConvite/" + id, { idioma: idioma });
                    return;
                }
                history.push("/cadastroEventoParticipanteConviteConcluido/" + idEvento, { idioma: idioma });
            })
            .catch(function () {
                const message = idioma
                    ? `${getText('error', idioma)} ${getText('errorSavingDefault', idioma)}`
                    : <>{getText('error', 'portugues')} {getText('errorSavingDefault', 'portugues')}<br />({getText('error', 'ingles')} {getText('errorLoadingDefault', 'ingles')})</>;
                toast.error(message);
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate sidebar={['listarsvp', 'cliente'].includes(perfil) ? false : true} processando={isLoading} idioma={idioma ?? "both"}>
            <div className="main-content container-fluid">
                <div className="page-title">
                    <h3>{getText('confirmacao_dados_titulo', idioma)}</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        {!isLoading && !isError && dados.evento?.id && <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                                            <div className="row">
                                                {(dados.evento?.camposQuestionario?.nome ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-floating form-group">
                                                            <input type="text" className="form-control form-control-lg" id="nome" placeholder={getText('nome_completo_documento', idioma)}
                                                                value={dados.nome ?? ''}
                                                                onChange={e => setDados({ ...dados, ...{ "nome": e.target.value } })}
                                                            />
                                                            <label htmlFor="floatingInput">{getText('nome_completo_documento_label', idioma)}</label>
                                                        </div>
                                                        <div><strong>{getText('nome_atencao_aereo', idioma)}</strong></div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.contato ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-floating form-group">
                                                            <input type="text" className="form-control form-control-lg" id="contato" placeholder={getText('nome_cracha', idioma)}
                                                                value={dados.contato ?? ''}
                                                                onChange={e => setDados({ ...dados, ...{ "contato": e.target.value } })}
                                                            />
                                                            <label htmlFor="floatingInput">{getText('nome_cracha_label', idioma)}</label>
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.celular ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-floating form-group">
                                                            <InputMask mask="(99) 99999-9999" className="form-control form-control-lg" id="celular" placeholder={getText('celular', idioma)}
                                                                value={dados.celular ?? ''}
                                                                onChange={e => setDados({ ...dados, ...{ "celular": e.target.value } })}
                                                            />
                                                            <label htmlFor="floatingInput">{getText('celular_label', idioma)}</label>
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.telefone ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-floating form-group">
                                                            <InputMask mask="(99) 99999-9999" className="form-control form-control-lg" id="telefone" placeholder={getText('telefone', idioma)}
                                                                value={dados.telefone ?? ''}
                                                                onChange={e => setDados({ ...dados, ...{ "telefone": e.target.value } })}
                                                            />
                                                            <label htmlFor="floatingInput">{getText('telefone_label', idioma)}</label>
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.email ?? "nao") === "sim" ?
                                                    <div className="col-sm-8">
                                                        <div className="form-floating form-group">
                                                            <input type="text" className="form-control form-control-lg" id="email" placeholder={getText('email', idioma)}
                                                                value={dados.email ?? ''}
                                                                onChange={e => setDados({ ...dados, ...{ "email": e.target.value } })}
                                                            />
                                                            <label htmlFor="floatingInput">{getText('email_label', idioma)}</label>
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.rg ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-floating form-group">
                                                            <input type="text" className="form-control form-control-lg" id="rg" placeholder={getText('rg', idioma)}
                                                                value={dados.rg ?? ''}
                                                                onChange={e => setDados({ ...dados, ...{ "rg": e.target.value } })}
                                                            />
                                                            <label htmlFor="floatingInput">{getText('rg_label', idioma)}</label>
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.cpf ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-floating form-group">
                                                            <InputMask mask="999.999.999-99" className="form-control form-control-lg" id="cpf" placeholder={getText('cpf', idioma)}
                                                                value={dados.cpf ?? ''}
                                                                onChange={e => setDados({ ...dados, ...{ "cpf": e.target.value } })}
                                                            />
                                                            <label htmlFor="floatingInput">{getText('cpf_label', idioma)}</label>
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.crm ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-floating form-group">
                                                            <InputMask
                                                                className="form-control form-control-lg"
                                                                id="crm"
                                                                mask="9999999"
                                                                placeholder={getText('crm', idioma)}
                                                                value={dados.crm ?? ''}
                                                                onChange={e => setDados({ ...dados, ...{ "crm": e.target.value } })}
                                                            />
                                                            <label htmlFor="floatingInput">{getText('crm_label', idioma)}</label>
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.crmuf ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-group">
                                                            <label>{getText('estado_crm_label', idioma)}</label>
                                                            <ReactSelect
                                                                id={"crmuf"}
                                                                value={{ value: dados.crmuf ?? '', label: dados.crmuf ?? '' }}
                                                                onChange={e => setDados({ ...dados, ...{ "crmuf": e.value, "nomeUf": e.label } })}
                                                                options={[
                                                                    { value: "AC", label: "AC" },
                                                                    { value: "AL", label: "AL" },
                                                                    { value: "AP", label: "AP" },
                                                                    { value: "AM", label: "AM" },
                                                                    { value: "BA", label: "BA" },
                                                                    { value: "CE", label: "CE" },
                                                                    { value: "DF", label: "DF" },
                                                                    { value: "ES", label: "ES" },
                                                                    { value: "GO", label: "GO" },
                                                                    { value: "MA", label: "MA" },
                                                                    { value: "MT", label: "MT" },
                                                                    { value: "MS", label: "MS" },
                                                                    { value: "MG", label: "MG" },
                                                                    { value: "PA", label: "PA" },
                                                                    { value: "PB", label: "PB" },
                                                                    { value: "PR", label: "PR" },
                                                                    { value: "PE", label: "PE" },
                                                                    { value: "PI", label: "PI" },
                                                                    { value: "RJ", label: "RJ" },
                                                                    { value: "RN", label: "RN" },
                                                                    { value: "RS", label: "RS" },
                                                                    { value: "RO", label: "RO" },
                                                                    { value: "RR", label: "RR" },
                                                                    { value: "SC", label: "SC" },
                                                                    { value: "SP", label: "SP" },
                                                                    { value: "SE", label: "SE" },
                                                                    { value: "TO", label: "TO" },
                                                                ]}
                                                            />
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.datanascimento ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <Data
                                                            id={"datanascimento"}
                                                            label={getText('data_nascimento_label', idioma)}
                                                            value={dados.datanascimento ?? ''}
                                                            onChange={date => setDados({ ...dados, ...{ "datanascimento": date } })}
                                                        />
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.especialidade ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-floating form-group">
                                                            <input type="text" className="form-control form-control-lg" id="especialidade" placeholder={getText('especialidade', idioma)}
                                                                value={dados.especialidade ?? ''}
                                                                onChange={e => setDados({ ...dados, ...{ "especialidade": e.target.value } })}
                                                            />
                                                            <label htmlFor="floatingInput">{getText('especialidade_label', idioma)}</label>
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.instituicao ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-floating form-group">
                                                            <input type="text" className="form-control form-control-lg" id="instituicao" placeholder={getText('instituicao', idioma)}
                                                                value={dados.instituicao ?? ''}
                                                                onChange={e => setDados({ ...dados, ...{ "instituicao": e.target.value } })}
                                                            />
                                                            <label htmlFor="floatingInput">{getText('instituicao_label', idioma)}</label>
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.enderecocep ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-floating form-group">
                                                            <input type="text" className="form-control form-control-lg" id="enderecocep" placeholder={getText('cep', idioma)}
                                                                value={dados.enderecocep ?? ''}
                                                                onChange={(e) => {
                                                                    dados.enderecocep = e.target.value;
                                                                    preencherCep(e.target.value, dados);
                                                                    setDados({ ...dados });
                                                                }}
                                                            />
                                                            <label htmlFor="floatingInput">{getText('cep_label', idioma)}</label>
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.enderecologradouro ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-floating form-group">
                                                            <input type="text" className="form-control form-control-lg" id="enderecologradouro" placeholder={getText('rua_logradouro', idioma)}
                                                                value={dados.enderecologradouro ?? ''}
                                                                onChange={e => setDados({ ...dados, ...{ "enderecologradouro": e.target.value } })}
                                                            />
                                                            <label htmlFor="floatingInput">{getText('rua_logradouro_label', idioma)}</label>
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.endereconumero ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-floating form-group">
                                                            <input type="text" className="form-control form-control-lg" id="endereconumero" placeholder={getText('numero', idioma)}
                                                                value={dados.endereconumero ?? ''}
                                                                onChange={e => setDados({ ...dados, ...{ "endereconumero": e.target.value } })}
                                                            />
                                                            <label htmlFor="floatingInput">{getText('numero_label', idioma)}</label>
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.enderecocomplemento ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-floating form-group">
                                                            <input type="text" className="form-control form-control-lg" id="enderecocomplemento" placeholder={getText('complemento', idioma)}
                                                                value={dados.enderecocomplemento ?? ''}
                                                                onChange={e => setDados({ ...dados, ...{ "enderecocomplemento": e.target.value } })}
                                                            />
                                                            <label htmlFor="floatingInput">{getText('complemento_label', idioma)}</label>
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.enderecobairro ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-floating form-group">
                                                            <input type="text" className="form-control form-control-lg" id="enderecobairro" placeholder={getText('bairro', idioma)}
                                                                value={dados.enderecobairro ?? ''}
                                                                onChange={e => setDados({ ...dados, ...{ "enderecobairro": e.target.value } })}
                                                            />
                                                            <label htmlFor="floatingInput">{getText('bairro_label', idioma)}</label>
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.enderecomunicipio ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-group">
                                                            <label>{getText('cidade_label', idioma)}</label>
                                                            <ReactSelect
                                                                value={{ value: dados.enderecomunicipio ?? '', label: dados.nomeEnderecomunicipio ?? '' }}
                                                                onChange={e => setDados({ ...dados, ...{ "enderecomunicipio": e.value, "nomeEnderecomunicipio": e.label } })}
                                                                loadOptions={(input) => {
                                                                    return api({
                                                                        method: 'get',
                                                                        action: '/municipio',
                                                                        token: token,
                                                                        params: {
                                                                            nome: input,
                                                                            uf: dados.enderecouf ?? ''
                                                                        }
                                                                    })
                                                                        .then(response => {
                                                                            let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome + "-" + registro.uf }));
                                                                            return options;
                                                                        })
                                                                        .catch(function (error) {
                                                                            //console.log(error);
                                                                        });
                                                                }}
                                                            />
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.enderecouf ?? "nao") === "sim" ?
                                                    <div className="col-sm-4">
                                                        <div className="form-group">
                                                            <label>{getText('estado_label', idioma)}</label>
                                                            <ReactSelect
                                                                id={"enderecouf"}
                                                                value={{ value: dados.enderecouf ?? '', label: dados.enderecouf ?? '' }}
                                                                onChange={e => setDados({ ...dados, ...{ "enderecouf": e.value, "nomeUf": e.label } })}
                                                                options={[
                                                                    { value: "AC", label: "AC" },
                                                                    { value: "AL", label: "AL" },
                                                                    { value: "AP", label: "AP" },
                                                                    { value: "AM", label: "AM" },
                                                                    { value: "BA", label: "BA" },
                                                                    { value: "CE", label: "CE" },
                                                                    { value: "DF", label: "DF" },
                                                                    { value: "ES", label: "ES" },
                                                                    { value: "GO", label: "GO" },
                                                                    { value: "MA", label: "MA" },
                                                                    { value: "MT", label: "MT" },
                                                                    { value: "MS", label: "MS" },
                                                                    { value: "MG", label: "MG" },
                                                                    { value: "PA", label: "PA" },
                                                                    { value: "PB", label: "PB" },
                                                                    { value: "PR", label: "PR" },
                                                                    { value: "PE", label: "PE" },
                                                                    { value: "PI", label: "PI" },
                                                                    { value: "RJ", label: "RJ" },
                                                                    { value: "RN", label: "RN" },
                                                                    { value: "RS", label: "RS" },
                                                                    { value: "RO", label: "RO" },
                                                                    { value: "RR", label: "RR" },
                                                                    { value: "SC", label: "SC" },
                                                                    { value: "SP", label: "SP" },
                                                                    { value: "SE", label: "SE" },
                                                                    { value: "TO", label: "TO" },
                                                                ]}
                                                            />
                                                        </div>
                                                    </div> : null}
                                                {(((dados.aereo ?? "nao") === "sim") && ((dados.evento?.camposQuestionario?.aereomunicipioembarque ?? "nao") === "sim")) ?
                                                    <div className="col-sm-4">
                                                        <div className="form-group">
                                                            <label>{getText('cidade_embarque_label', idioma)}</label>
                                                            <ReactSelect
                                                                value={{ value: dados.aereomunicipioembarque ?? '', label: dados.nomeAereomunicipioembarque ?? '' }}
                                                                onChange={e => setDados({ ...dados, ...{ "aereomunicipioembarque": e.value, "nomeAereomunicipioembarque": e.label } })}
                                                                loadOptions={(input) => {
                                                                    return api({
                                                                        method: 'get',
                                                                        action: '/municipio',
                                                                        token: token,
                                                                        params: {
                                                                            nome: input,
                                                                            uf: dados.enderecouf ?? ''
                                                                        }
                                                                    })
                                                                        .then(response => {
                                                                            let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome + "-" + registro.uf }));
                                                                            return options;
                                                                        })
                                                                        .catch(function (error) {
                                                                            //console.log(error);
                                                                        });
                                                                }}
                                                            />
                                                        </div>
                                                    </div> : null}
                                                {(dados.evento?.camposQuestionario?.necessidadeespecial ?? "nao") === "sim" ?
                                                    <>
                                                        <hr />
                                                        <p>{getText('necessidade_especial_descricao', idioma)}</p>
                                                        <div className="col-sm-4">
                                                            <div className="form-group">
                                                                <div className="d-flex flex-column">
                                                                    <div className="mb-2">
                                                                        <input type="checkbox"
                                                                            id="restricaoalimentarCheck"
                                                                            checked={dados.restricaoalimentarCheck ?? false}
                                                                            onChange={e => {
                                                                                const isChecked = e.target.checked;
                                                                                setDados({
                                                                                    ...dados,
                                                                                    restricaoalimentarCheck: isChecked,
                                                                                    restricaoalimentar: isChecked ? dados.restricaoalimentar : ''
                                                                                });
                                                                            }}
                                                                            className="me-2"
                                                                        />
                                                                        <label htmlFor="restricaoalimentarCheck">{getText('restricao_alimentar_label', idioma)}</label>
                                                                    </div>
                                                                    <input type="text" className="form-control form-control-lg" id="restricaoalimentar" placeholder={getText('especifique_restricao_alimentar', idioma)}
                                                                        value={dados.restricaoalimentar ?? ''}
                                                                        onChange={e => {
                                                                            const value = e.target.value;
                                                                            setDados({
                                                                                ...dados,
                                                                                restricaoalimentar: value,
                                                                                restricaoalimentarCheck: value ? true : dados.restricaoalimentarCheck
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-4">
                                                            <div className="form-group">
                                                                <div className="d-flex flex-column">
                                                                    <div className="mb-2">
                                                                        <input type="checkbox"
                                                                            id="pcdCheck"
                                                                            checked={dados.pcdCheck ?? false}
                                                                            onChange={e => {
                                                                                const isChecked = e.target.checked;
                                                                                setDados({
                                                                                    ...dados,
                                                                                    pcdCheck: isChecked,
                                                                                    pcd: isChecked ? dados.pcd : ''
                                                                                });
                                                                            }}
                                                                            className="me-2"
                                                                        />
                                                                        <label htmlFor="pcdCheck">{getText('pcd_label', idioma)}</label>
                                                                    </div>
                                                                    <input type="text" className="form-control form-control-lg" id="pcd" placeholder={getText('especifique_necessidade_especial', idioma)}
                                                                        value={dados.pcd ?? ''}
                                                                        onChange={e => {
                                                                            const value = e.target.value;
                                                                            setDados({
                                                                                ...dados,
                                                                                pcd: value,
                                                                                pcdCheck: value ? true : dados.pcdCheck
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <hr />
                                                    </>
                                                    : null}
                                                {[...Array(10)].map((_, i) => {
                                                    const coluna = `coluna${i + 1}`;
                                                    const nomeColuna = `nomecoluna${i + 1}`;
                                                    return (dados.evento?.camposQuestionario?.[coluna] ?? "nao") === "sim" ? (
                                                        <div className="col-sm-4" key={i}>
                                                            <div className="form-floating form-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-lg"
                                                                    id={coluna}
                                                                    placeholder={dados.evento?.[nomeColuna] ?? `Coluna ${i + 1}`}
                                                                    value={dados[coluna] ?? ''}
                                                                    onChange={e => setDados({ ...dados, [coluna]: e.target.value })}
                                                                />
                                                                <label htmlFor="floatingInput">{dados.evento?.[nomeColuna] ?? `Coluna ${i + 1}`}</label>
                                                            </div>
                                                        </div>
                                                    ) : null;
                                                })}
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 d-flex justify-content-end">
                                                    <button type="submit" className="btn btn-primary me-1 mb-1" disabled={isSubmitting}>
                                                        <FaSave size={20} /> {getText('confirmar_dados_botao', idioma)}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
            </div >
        </ErpTemplate >
    );
}